import { apiSauceInstance } from '../../../services/api'
import { EdgesPage } from '@elentari/core/types'
import { makeRepository } from '@elentari/core/utils/makeRepository'
import { ParsedQs } from 'qs'
import { paginationParams } from '../../../utils/paginationQueryParams'
import {
  UnidadeNegocio,
  UnidadeNegocioDetail,
  AlterarStatusData,
  StatusUnidadesNegocio
} from '../types'

const mapQueryParams = (params: ParsedQs): ParsedQs => {
  const { limit, ...rest } = params

  return {
    ...paginationParams(rest),
    limit: limit || '10'
  }
}

export const unidadeNegocioRepository = makeRepository<
  EdgesPage<UnidadeNegocioDetail>,
  UnidadeNegocio,
  UnidadeNegocioDetail,
  string
>({ resource: 'unidades-negocio', mapQueryParams }, apiSauceInstance)

export const alterarStatus = async (id: string, data: AlterarStatusData) => {
  return apiSauceInstance.patch<
    { status: StatusUnidadesNegocio },
    { message: string; error: any }
  >(`/unidades-negocio/${id}/alterar-status/`, data)
}
